import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenericCameraSettings } from '@pages/camera-settings/models';
import { OrganizationService } from '@services/organization.service';
import { RoleService } from '@services/role.service';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

export interface Organization {
    CompanyId: number;
    Name: string;
}
export interface Role {
    ID: number;
    RoleName: string;
}

@Component({
    selector: 'app-selection-dialog',
    templateUrl: './selection-dialog.component.html',
    styleUrls: ['./selection-dialog.component.scss']
})
export class SelectionDialogComponent {
    ModifiedProps: GenericCameraSettings[] = [];
    organizations: Organization[] = [];
    selectedOrganizationId: number = 1;
    selectedRoleId: number = 1;
    roles: Role[] = [];
    updateType: string = 'Organization';
    faTimes = faTimes;
    userId: number = 0;
    userName: string = '';

    UndoClick = new EventEmitter();
    constructor(
        @Inject(OrganizationService) public organizationsService,
        @Inject(RoleService) public roleService,
        public dialogRef: MatDialogRef<SelectionDialogComponent>
    ) {
        this.organizationsService
            .getOrganizations()
            .subscribe((data: Organization[]) => {
                data = data.sort((a, b) =>
                    a.CompanyId > b.CompanyId ? 1 : -1
                );
                this.organizations = data;
            });

        this.roleService.getRoles().subscribe((data: Role[]) => {
            data = data.sort((a, b) => (a.ID > b.ID ? 1 : -1));
            this.roles = data;
        });

        this.dialogRef.backdropClick().subscribe(() => {
            // Close the dialog
            dialogRef.close();
          });
    }

    onOrganizationChange($event: any) {
        this.selectedOrganizationId = $event.value;
    }
    onRoleChange($event: any) {
        this.selectedRoleId = $event.value;
    }
    onTypeChange($event: any) {
        console.log($event.value);
        this.updateType = $event.value;
    }

    closeDialog() {
        this.dialogRef.close({
            Status: false,
            OrganizationId: this.selectedOrganizationId,
            OrganizationName: this.organizations.find(x => x.CompanyId == this.selectedOrganizationId).Name,
            RoleId: this.selectedRoleId,
            RoleName: this.roles.find(x => x.ID == this.selectedRoleId).RoleName,
            UpdateType: this.updateType
        });
    }
    onSuccessClick() {
        this.dialogRef.close({
            Status: true,
            OrganizationId: this.selectedOrganizationId,
            OrganizationName: this.organizations.find(x => x.CompanyId == this.selectedOrganizationId).Name,
            RoleName: this.roles.find(x => x.ID == this.selectedRoleId).RoleName,
            RoleId: this.selectedRoleId,
            UpdateType: this.updateType
        });
    }
    resetProp(propertyName: string) {
        this.UndoClick.emit(propertyName);
        this.ModifiedProps = this.ModifiedProps.filter(x => x.propertyName != propertyName);
    }
}
